module.exports = __webpack_public_path__ + "static/media/YAB7.09e4cbe5.jpg";